export default __webpack_public_path__ + "static/media/24.ab73dba3.png";